import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/css/reset.css'
import animated from 'animate.css'
import 'animate.css'
import prismjs from './css/prism.js'
import prismCss from './css/prism.css'
// import jsCookie from 'js-cookie'

Vue.use(ElementUI);
Vue.use(animated);
Vue.use(prismjs)
Vue.use(prismCss)
Vue.config.productionTip = false
// Vue.prototype.$cookie = jsCookie;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
